import React from 'react';
import Menu from '../../components/menu/Menu';
import Footer from '../../components/Footer/Footer';
import '../PrivacyPolicy/css/PrivacyPolicy.css';

const TermsOfUse = () => {
  return (
    <div>
      <Menu />
      <div className="policy-page">
        <div className="policy-container">
          <div className="policy-header">
            <h1>Пользовательское соглашение</h1>
            <p className="policy-update">Последнее обновление: 18 ноября 2025 года</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Общие положения</h2>
              <p>
                1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения 
                между ООО "АЛЬТКОР" (далее — «Компания», «Мы») и Пользователем (далее — «Пользователь», «Вы») 
                в отношении использования веб-сайта altcor.ru, программного обеспечения ALTCOR AI и сопутствующих 
                услуг (далее — «Сервис»).
              </p>
              <p>
                1.2. Используя Сервис, Вы подтверждаете свое согласие с условиями настоящего Соглашения 
                в полном объеме. Если Вы не согласны с какими-либо условиями Соглашения, Вы должны 
                немедленно прекратить использование Сервиса.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Определения терминов</h2>
              <div className="terms-list">
                <div className="term-item">
                  <strong>Пользователь</strong> - любое физическое или юридическое лицо, использующее 
                  продукты и услуги Компании.
                </div>
                <div className="term-item">
                  <strong>Сервис</strong> - программный комплекс ALTCOR AI, веб-сайт altcor.ru и сопутствующие услуги.
                </div>
                <div className="term-item">
                  <strong>Контент</strong> - любая информация, размещаемая Пользователем в Сервисе.
                </div>
                <div className="term-item">
                  <strong>Учетная запись</strong> - учетные данные Пользователя для доступа к Сервису.
                </div>
                <div className="term-item">
                  <strong>Cookies</strong> - небольшие текстовые файлы, сохраняемые на устройстве Пользователя.
                </div>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Регистрация и учетная запись</h2>
              <p>3.1. Для использования полного функционала Сервиса требуется регистрация учетной записи.</p>
              <p>3.2. При регистрации Пользователь обязуется:</p>
              <ul className="policy-list">
                <li>Предоставлять достоверную, точную и полную информацию о себе</li>
                <li>Обновлять регистрационные данные в случае их изменения</li>
                <li>Обеспечивать конфиденциальность своих учетных данных</li>
              </ul>
              <p>
                3.3. Компания вправе заблокировать или удалить учетную запись Пользователя при нарушении 
                условий настоящего Соглашения.
              </p>
            </section>

            <section className="policy-section">
              <h2>4. Права и обязанности сторон</h2>
              
              <h3>4.1. Права Компании:</h3>
              <ul className="policy-list">
                <li>Изменять условия Соглашения с уведомлением Пользователей за 10 дней до вступления изменений в силу</li>
                <li>Приостанавливать работу Сервиса для проведения плановых технических работ</li>
                <li>Отказывать в доступе к Сервису при нарушении условий Соглашения</li>
                <li>Собирать анонимизированную статистическую информацию об использовании Сервиса</li>
                <li>Разрабатывать и внедрять новые функции и услуги</li>
              </ul>

              <h3>4.2. Обязанности Компании:</h3>
              <ul className="policy-list">
                <li>Обеспечивать работоспособность Сервиса в соответствии с его функциональным назначением</li>
                <li>Обеспечивать защиту персональных данных Пользователей в соответствии с законодательством</li>
                <li>Предоставлять техническую поддержку Пользователям</li>
                <li>Соблюдать конфиденциальность информации Пользователей</li>
              </ul>

              <h3>4.3. Права Пользователя:</h3>
              <ul className="policy-list">
                <li>Использовать Сервис в соответствии с его функциональным назначением</li>
                <li>Получать техническую поддержку от Компании</li>
                <li>Требовать устранения недостатков Сервиса в установленном порядке</li>
                <li>Отказаться от использования Сервиса в любое время</li>
              </ul>

              <h3>4.4. Обязанности Пользователя:</h3>
              <ul className="policy-list">
                <li>Соблюдать условия настоящего Соглашения и действующее законодательство</li>
                <li>Не передавать свои учетные данные третьим лицам</li>
                <li>Не использовать Сервис для противоправных целей</li>
                <li>Не предпринимать попытки обойти технические ограничения Сервиса</li>
                <li>Не размещать запрещенный контент</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Интеллектуальная собственность</h2>
              <p>
                5.1. Все права на программное обеспечение, дизайн, базы данных, графические элементы, 
                текстовую информацию и иные элементы Сервиса принадлежат Компании или правомерным правообладателям.
              </p>
              <p>
                5.2. Пользователю предоставляется непередаваемая, неисключительная лицензия на использование 
                Сервиса в соответствии с его функциональным назначением и условиями настоящего Соглашения.
              </p>
              <p>
                5.3. Любое копирование, воспроизведение, распространение или иное использование материалов 
                Сервиса без письменного разрешения Компании запрещено.
              </p>
            </section>

            <section className="policy-section">
              <h2>6. Ограничения использования</h2>
              <p>Запрещается использовать Сервис для:</p>
              <ul className="policy-list">
                <li>Распространения вредоносного программного обеспечения, спама или фишинговых атак</li>
                <li>Осуществления несанкционированного доступа к данным других пользователей или систем</li>
                <li>Размещения контента, нарушающего права третьих лиц или законодательство РФ</li>
                <li>Использования автоматизированных средств для сбора информации без разрешения</li>
                <li>Совершения действий, нарушающих нормальную работу Сервиса или создающих чрезмерную нагрузку</li>
                <li>Распространения порнографических материалов, пропаганды насилия и экстремизма</li>
                <li>Осуществления мошеннической деятельности</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>7. Использование файлов cookie</h2>
              <p>
                7.1. Сервис использует файлы cookie и аналогичные технологии для обеспечения корректной работы, 
                анализа использования и улучшения качества предоставляемых услуг.
              </p>
              
              <h3>7.2. Типы используемых cookie:</h3>
              <ul className="policy-list">
                <li>
                  <strong>Необходимые</strong> - обеспечивают базовую функциональность Сервиса 
                  (авторизация, безопасность, корзина)
                </li>
                <li>
                  <strong>Функциональные</strong> - запоминают ваши предпочтения и настройки
                </li>
                <li>
                  <strong>Аналитические</strong> - помогают нам понимать, как Пользователи взаимодействуют с Сервисом
                </li>
                <li>
                  <strong>Маркетинговые</strong> - используются для показа релевантной рекламы и оценки эффективности кампаний
                </li>
              </ul>

              <p>
                7.3. Продолжая использовать Сервис, Вы соглашаетесь на использование файлов cookie 
                в соответствии с настоящим Соглашением и нашей Политикой конфиденциальности.
              </p>
              <p>
                7.4. Вы можете управлять использованием cookie через настройки своего браузера, 
                однако это может ограничить функциональность Сервиса.
              </p>
            </section>

            <section className="policy-section">
              <h2>8. Ответственность сторон</h2>
              <p>
                8.1. Компания прилагает все разумные усилия для обеспечения бесперебойной работы Сервиса, 
                однако не гарантирует отсутствия временных сбоев и ошибок.
              </p>
              <p>
                8.2. Компания не несет ответственности за:
              </p>
              <ul className="policy-list">
                <li>Прямые или косвенные убытки, возникшие в результате использования или невозможности использования Сервиса</li>
                <li>Действия или бездействие третьих лиц, влияющие на работу Сервиса</li>
                <li>Неправомерные действия Пользователей с использованием Сервиса</li>
                <li>Потерю данных по причинам, не зависящим от Компании</li>
              </ul>
              <p>
                8.3. Пользователь несет полную ответственность за содержание размещаемого контента 
                и его соответствие законодательству Российской Федерации.
              </p>
              <p>
                8.4. В случае нарушения Пользователем условий Соглашения, Компания вправе требовать 
                возмещения причиненных убытков.
              </p>
            </section>

            <section className="policy-section">
              <h2>9. Тарифы и оплата</h2>
              <p>9.1. Компания вправе устанавливать плату за использование отдельных функций Сервиса.</p>
              <p>9.2. Тарифные планы и условия оплаты публикуются на официальном сайте Компании.</p>
              <p>9.3. Оплата производится в порядке, установленном Компанией, с использованием доступных способов оплаты.</p>
              <p>
                9.4. Компания вправе изменять тарифы с уведомлением Пользователей за 30 дней до вступления изменений в силу.
              </p>
              <p>
                9.5. Возврат средств осуществляется в соответствии с законодательством Российской Федерации 
                и правилами Компании.
              </p>
            </section>

            <section className="policy-section">
              <h2>10. Конфиденциальность</h2>
              <p>
                10.1. Обработка персональных данных Пользователя осуществляется в соответствии с 
                Политикой конфиденциальности, являющейся неотъемлемой частью настоящего Соглашения.
              </p>
              <p>
                10.2. Компания обязуется принимать все необходимые меры для защиты конфиденциальной 
                информации Пользователя.
              </p>
              <p>
                10.3. Пользователь соглашается с тем, что техническая информация о использовании Сервиса 
                может собираться и обрабатываться для улучшения качества услуг.
              </p>
            </section>

            <section className="policy-section">
              <h2>11. Заключительные положения</h2>
              <p>
                11.1. Настоящее Соглашение вступает в силу с момента его принятия Пользователем 
                и действует до момента его отзыва или прекращения действия.
              </p>
              <p>
                11.2. Компания вправе в одностороннем порядке изменять условия Соглашения с обязательным 
                уведомлением Пользователей.
              </p>
              <p>
                11.3. Все споры и разногласия, возникающие из настоящего Соглашения, подлежат разрешению 
                в соответствии с законодательством Российской Федерации.
              </p>
              <p>
                11.4. Признание отдельных положений Соглашения недействительными не влечет недействительности 
                Соглашения в целом.
              </p>
              <p>
                11.5. Актуальная версия Соглашения доступна по адресу: <strong>https://altcor.ru/terms</strong>
              </p>
            </section>

           <section className="policy-section">
              <h2>12. Контактная информация</h2>
              <div className="contact-info-section">
                <p><strong>Общество с ограниченной ответственностью "АЛЬТКОР"</strong></p>
                <div className="details-grid">
                  <div className="detail-item">
                    <span className="detail-label">ИНН:</span>
                    <span>9718280720</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">КПП:</span>
                    <span>771801001</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">ОГРН:</span>
                    <span>1257700217246</span>
                  </div>
                </div>
                <div className="contact-info">
                  <p><strong>Email:</strong> info@altcor.ru</p>
                  <p><strong>Телефон:</strong> +7 (495) 902-03-02</p>
                  <p><strong>Адрес для корреспонденции:</strong> 107023, город Москва, Суворовская ул, д. 19 стр. 1, помещ. 17 </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;